// i18next-extract-mark-ns-start LandingAds
import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { withTranslation } from 'gatsby-plugin-react-i18next';

import { Container, Content } from '../components/home/v2/styledComponents';
import ReferrerBanner from '../components/home/ReferrerBanner';
import MenuBar from '../components/home/MenuBar';
import FootNote from '../components/LandingPage/FootNote';
import FooterSEOLinks from '../components/LandingPage/FooterSEOLinks';
import Footer from '../components/home/v3/Footer';
import Layout from '../layouts/index';
import CoutureServices from '../components/home/OurServices/CoutureServices';
import { getFAQ } from '../pagesComponents/home/LandingAds2';

import {
  getFootNoteTitle, getBreadCrumb,
} from './LandingLocalityFormatter';

class LandingLocalityPageTemplate extends React.Component {
  componentDidMount() {
    if (typeof window === 'undefined') return;
    window.scrollTo(0, 0);
    window.onbeforeunload = null;
  }

  render() {
    const { t, data: { landingsLocalitiesJson }, referrer } = this.props;
    const {
      slug, city, locality, arrondissement, paragraph, links,
    } = landingsLocalitiesJson;
    const preFilledSteps = { selectedCategory: 'clothes' };
    const faqQuestions = [...getFAQ(t, city, false)].map((faqQuestion) => {
      faqQuestion.answers = faqQuestion.answers || [faqQuestion.answer];
      return faqQuestion;
    });

    return (
      <Layout routeSlug={slug} city={city}>
        <Container>
          <Content full hasNoBanner>
            {referrer && <ReferrerBanner referrer={referrer} />}
            <MenuBar />
            <CoutureServices
              arrondissement={arrondissement}
              locality={locality || city}
              faqQuestions={faqQuestions}
              preFilledSteps={preFilledSteps}
              preSelectedRange="dressing"
            />
            <FootNote
              title={getFootNoteTitle({
                t, locality, city, arrondissement,
              })}
              paragraph={paragraph}
              links={links}
              itemListElement={getBreadCrumb({
                t, locality, city, arrondissement,
              })}
            />
            <FooterSEOLinks city={city} locality={locality} arrondissement={arrondissement} />
            <Footer />
          </Content>
        </Container>
      </Layout>
    );
  }
}

LandingLocalityPageTemplate.propTypes = {
  data: PropTypes.shape({
    landingsLocalitiesJson: PropTypes.shape({
      slug: PropTypes.string,
      city: PropTypes.string,
      locality: PropTypes.string,
      arrondissement: PropTypes.string,
      paragraph: PropTypes.string,
      links: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
  }).isRequired,
  referrer: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
};

LandingLocalityPageTemplate.defaultProps = {
  referrer: null,
};

export default withTranslation()(LandingLocalityPageTemplate);

export const landingLocalityPageQuery = graphql`
query landingsLocalitiesQuery($slug: String!) {
  landingsLocalitiesJson(slug: { eq: $slug }) {
    slug
    city
    locality
    zipcode
    arrondissement
    paragraph
    links
  }
}`;
